import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <header className="app-header">
      <div className="app-logo">NetWorth</div>

      <div className="header-actions">
        <button
          className="header-icon-btn"
          onClick={() => navigate('/settings')}
          aria-label="Settings"
        >
          <Settings size={20} />
        </button>
        <button
          className="header-icon-btn"
          onClick={logout}
          aria-label="Sign out"
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default AppHeader;
